import dayjs from 'dayjs'
import { useState } from 'react'

// antd
import { MdDelete } from 'react-icons/md'
import { RiEditFill } from 'react-icons/ri'
import { PlusOutlined } from '@ant-design/icons'
import { Col, Divider, Row, Tag, Tooltip, Typography } from 'antd'

// components
import ExperienceForm from './experienceForm'
import { useDispatch, useSelector } from 'react-redux'
import { removeExperienceDraft } from '../../store/applicationDraft.slice'

const ExperienceSection = () => {
    const { Title, Text } = Typography
    const [editData, setEditData] = useState(null)
    const [showExperienceForm, setShowExperienceForm] = useState(false)

    const dispatch = useDispatch()

    const { experience } = useSelector((state) => state.applicationDraftSlice)

    return (
        <div>
            <div style={{ marginTop: '15px' }}>
                <div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: '10px',
                        }}
                    >
                        <Title level={5}>Experience (Optional)</Title>
                        <Tooltip title="Add Experience">
                            <button
                                style={{
                                    width: '26px',
                                    height: '26px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '10px',
                                    borderRadius: '50%',
                                    border: 'none',
                                }}
                                onClick={() => {
                                    setShowExperienceForm(true)
                                    setEditData(null)
                                }}
                            >
                                <PlusOutlined style={{ fontSize: '15px' }} />
                            </button>
                        </Tooltip>
                    </div>
                    {experience?.length > 0 && (
                        <div style={{ marginTop: '15px' }}>
                            {experience?.map((e) => {
                                const isEditing =
                                    editData !== null &&
                                    editData?._tempId === e?._tempId &&
                                    showExperienceForm
                                return isEditing ? (
                                    <div
                                        key={e._tempId}
                                        style={{ marginBottom: '20px' }}
                                    >
                                        <ExperienceForm
                                            onCancel={() => {
                                                setShowExperienceForm(false)
                                                setEditData(null)
                                            }}
                                            currentData={editData}
                                        />
                                    </div>
                                ) : (
                                    <Row gutter={25} key={e._tempId}>
                                        <Col
                                            xs={4}
                                            sm={4}
                                            md={4}
                                            lg={4}
                                            xl={4}
                                            style={{
                                                border: '1px solid #f0f0f0 ',
                                                padding: '10px',
                                                height: '100%',
                                                borderRadius: '8px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <div className="educationSvgLogo" />
                                        </Col>
                                        <Col
                                            xs={20}
                                            sm={20}
                                            md={20}
                                            lg={20}
                                            xl={20}
                                        >
                                            <div>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        columnGap: '10px',
                                                        justifyContent:
                                                            'space-between',
                                                    }}
                                                >
                                                    <Title level={5}>
                                                        {e?.title}
                                                    </Title>

                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            columnGap: '10px',
                                                        }}
                                                    >
                                                        <Tooltip title="Edit Experience">
                                                            <span
                                                                style={{
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() => {
                                                                    setShowExperienceForm(
                                                                        true
                                                                    )
                                                                    setEditData(
                                                                        e
                                                                    )
                                                                }}
                                                            >
                                                                <RiEditFill
                                                                    size={20}
                                                                />
                                                            </span>
                                                        </Tooltip>
                                                        <Tooltip title="Delete Education">
                                                            <span
                                                                style={{
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() => {
                                                                    dispatch(
                                                                        removeExperienceDraft(
                                                                            e?._tempId
                                                                        )
                                                                    )
                                                                }}
                                                            >
                                                                <MdDelete
                                                                    size={20}
                                                                />
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                </div>

                                                <div
                                                    style={{
                                                        marginTop: '5px',
                                                    }}
                                                >
                                                    {e?.company?.label && (
                                                        <>
                                                            <Text
                                                                style={{
                                                                    fontSize:
                                                                        '14px',
                                                                    marginRight:
                                                                        '10px',
                                                                }}
                                                            >
                                                                {
                                                                    e?.company
                                                                        ?.label
                                                                }
                                                            </Text>
                                                            {e?.location && (
                                                                <Text
                                                                    style={{
                                                                        fontSize:
                                                                            '14px',
                                                                        marginRight:
                                                                            '10px',
                                                                    }}
                                                                >
                                                                    |
                                                                </Text>
                                                            )}
                                                        </>
                                                    )}

                                                    {e?.location && (
                                                        <>
                                                            <Text
                                                                style={{
                                                                    fontSize:
                                                                        '14px',
                                                                    marginRight:
                                                                        '10px',
                                                                }}
                                                            >
                                                                {e?.location}
                                                            </Text>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            {e?.startDate != null && (
                                                <div
                                                    style={{
                                                        marginTop: '5px',
                                                    }}
                                                >
                                                    <Text
                                                        style={{
                                                            color: '#b9b9b9',
                                                            fontSize: '16px',
                                                        }}
                                                    >
                                                        <Text
                                                            style={{
                                                                color: '#b9b9b9',
                                                                fontSize:
                                                                    '16px',
                                                            }}
                                                        >
                                                            {dayjs(
                                                                e?.startDate
                                                            ).format(
                                                                'DD MMM YY'
                                                            )}
                                                        </Text>
                                                    </Text>
                                                    <Text
                                                        style={{
                                                            fontSize: '14px',
                                                            marginRight: '10px',
                                                            marginLeft: '10px',
                                                        }}
                                                    >
                                                        -
                                                    </Text>
                                                    <Text
                                                        style={{
                                                            color: '#b9b9b9',
                                                            fontSize: '16px',
                                                        }}
                                                    >
                                                        {!e.currentlyWorking && (
                                                            <Text
                                                                style={{
                                                                    color: '#b9b9b9',
                                                                    fontSize:
                                                                        '16px',
                                                                }}
                                                            >
                                                                {dayjs(
                                                                    e?.endDate
                                                                ).format(
                                                                    'DD MMM YY'
                                                                )}
                                                            </Text>
                                                        )}
                                                        {e.currentlyWorking && (
                                                            <Text
                                                                style={{
                                                                    color: '#b9b9b9',
                                                                    fontSize:
                                                                        '16px',
                                                                }}
                                                            >
                                                                Present
                                                            </Text>
                                                        )}
                                                    </Text>
                                                </div>
                                            )}
                                            {e?.summary && (
                                                <div
                                                    style={{
                                                        marginTop: '10px',
                                                        marginBottom: '10px',
                                                    }}
                                                >
                                                    <Text
                                                        style={{
                                                            fontSize: '14px',
                                                        }}
                                                    >
                                                        {e?.summary}
                                                    </Text>
                                                </div>
                                            )}
                                            <div>
                                                {e?.skills?.length > 0 && (
                                                    <>
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '15px',
                                                            }}
                                                        >
                                                            <div>
                                                                <Text
                                                                    style={{
                                                                        fontSize:
                                                                            '18px',
                                                                    }}
                                                                >
                                                                    Skills
                                                                </Text>
                                                            </div>
                                                        </div>
                                                        <Row gutter={10}>
                                                            {e?.skills?.map(
                                                                (
                                                                    skill,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <Tag
                                                                            key={
                                                                                index
                                                                            }
                                                                            bordered={
                                                                                false
                                                                            }
                                                                            color="processing"
                                                                            style={{
                                                                                marginTop:
                                                                                    '10px',
                                                                                cursor: 'auto',
                                                                            }}
                                                                        >
                                                                            {
                                                                                skill?.label
                                                                            }
                                                                        </Tag>
                                                                    )
                                                                }
                                                            )}
                                                        </Row>
                                                    </>
                                                )}
                                            </div>

                                            <div>
                                                {e?.tools?.length > 0 && (
                                                    <>
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '15px',
                                                            }}
                                                        >
                                                            <div>
                                                                <Text
                                                                    style={{
                                                                        fontSize:
                                                                            '18px',
                                                                    }}
                                                                >
                                                                    Tools
                                                                </Text>
                                                            </div>
                                                        </div>
                                                        <Row gutter={10}>
                                                            {e?.tools?.map(
                                                                (
                                                                    data,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <Tag
                                                                            key={
                                                                                index
                                                                            }
                                                                            bordered={
                                                                                false
                                                                            }
                                                                            color="processing"
                                                                            style={{
                                                                                marginTop:
                                                                                    '10px',
                                                                                cursor: 'auto',
                                                                            }}
                                                                        >
                                                                            {
                                                                                data?.label
                                                                            }
                                                                        </Tag>
                                                                    )
                                                                }
                                                            )}
                                                        </Row>
                                                    </>
                                                )}
                                            </div>
                                        </Col>
                                        <Divider />
                                    </Row>
                                )
                            })}
                        </div>
                    )}
                    {showExperienceForm && editData === null && (
                        <ExperienceForm
                            onCancel={() => setShowExperienceForm(false)}
                            currentData={null}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default ExperienceSection
